import { graphql } from '@/generated/gql';

export const BASE_PURCHASE_REQUISITION_LIST_QUERY = graphql(/* GraphQL */ `
  query BasePurchaseRequisitionList(
    $offset: Int
    $limit: Int
    $filter: JSON
    $order: [PurchaseRequisitionSortOrder!]
    $skipExport: Boolean = false
  ) {
    purchaseRequisitions(offset: $offset, limit: $limit, filter: $filter, order: $order) {
      nodes {
        description
        externalId
        id
        fixedSuppliersCount
        isBlocked
        lineItemsCount
        preferredSuppliersCount
        totalValue
        type
        primaryCommodityGroup
        commodityGroupCount
        commodityGroupList @skip(if: $skipExport) {
          id
          name
        }
        links @skip(if: $skipExport) {
          title
          url
        }
      }
      totalCount
    }
  }
`);
